export default __webpack_public_path__ + "static/media/interfaceEndKey.73a14268.svg";